import { createReducer, on } from '@ngrx/store';

import * as GridAction from './grid.actions';
import { gridInitialState } from './grid.state';

export const gridReducer = createReducer(
  gridInitialState,
  on(GridAction.setSkipRows, (state, { skipRows, gridName }) => ({
    ...state,
    [gridName]: { ...state[gridName], skipRows },
  })),
  on(
    GridAction.setSearchCriteria,
    (state, { searchCriteria, gridName }) => ({
      ...state,
      [gridName]: { ...state[gridName], searchCriteria },
    })
  ),
  on(
    GridAction.setIdentifier,
    (state, { identifier: identifier, gridName }) => ({
      ...state,
      [gridName]: { ...state[gridName], identifier },
    })
  ),
  on(GridAction.setPageNumber, (state, { pageNumber, gridName }) => ({
    ...state,
    [gridName]: {
      ...state[gridName],
      searchCriteria: {
        ...state[gridName].searchCriteria,
        pageNumber,
      },
    },
  })),
  on(GridAction.setRowsPerPage, (state, { rowsPerPage, gridName }) => ({
    ...state,
    [gridName]: {
      ...state[gridName],
      searchCriteria: {
        ...state[gridName].searchCriteria,
        rowsPerPage,
      },
    },
  })),
  on(GridAction.resetIdentifier, (state, { gridName }) => ({
    ...state,
    [gridName]: { ...state[gridName], identifier: undefined },
  }))
);
